import React from "react";
import { getUserPreference } from "../../../utilities/common";
import DailyLogTable from "./DailyLogTable/index"
import EditDailyHourDialog from "./EditDailyHourDialog/index"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { TextField, Button, Grid, IconButton, makeStyles } from "@material-ui/core";
import { Search, Refresh } from "@material-ui/icons";
import moment from "moment";
import { showAlertSnackbar } from '../../../reducers/uiSlice';
import _ from "lodash";
import {
  searchDailyLog,
  getPaymentCycle,
  createDailyLog,
  getChargeReason
} from "../../../actions/payRollAdjustmentAction";

const useStyles = makeStyles((theme) => ({
  grid: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'right',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(1), // 调整上方间距
    marginBottom: theme.spacing(1), // 调整下方间距
  },
  textField: {
    width: '100%',
  },
  Button: {
    display: 'flex',
    alignItems: 'right',
    marginRight: theme.spacing(-17),
    marginBottom: theme.spacing(-2),
  },
  searchButton: {
    marginBottom: theme.spacing(-2),
    backgroundColor: 'gray',
    color: 'white',
    '&:hover': {
      backgroundColor: 'darkgray',
    },
  },
  refreshButton: {
    marginBottom: theme.spacing(-2),
    backgroundColor: 'gray',
    color: 'white',
    '&:hover': {
      backgroundColor: 'darkgray',
    },
  },
  icon: {
    width: '21.9px',
    height: '21.9px',
  },
}));

function PayrollDailyLog() {
  const { t } = useTranslation('payrollAdjustment');
  const dispatch = useDispatch();
  const classes = useStyles();
  const userPref = getUserPreference();
  const [allDriverDetails, setAllDriverDetails] = useState([]);
  const [isDataLoading, setIsDataLoading] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [timezone, setTimezone] = useState('');
  const [selectedDate, setSelectedDate] = useState(moment().format("YYYY-MM-DD"));
  const [driverId, setDriverId] = useState("");
  const [batchInfo, setBatchInfo] = useState("");

  const handleSelectedItems = (items) => {
    setSelectedItem(items);
  }

  const handleSearch = () => {
    setIsDataLoading(true);
    const params = {
      date: selectedDate,
      batch_info: batchInfo,
      warehouse: userPref.userCity, // You may change this to the appropriate value
    };

    if (!_.isNil(driverId) && driverId !== "") {
      params.driver_id = driverId;
    }
    dispatch(searchDailyLog(params))
      .then((response) => {
        setAllDriverDetails(response);
        dispatch(showAlertSnackbar({
          title: t('daily_log'),
          message: t('dialog:daily_log_search_success'),
          type: 'success'
        }));
      })
      .catch((error) => {
        dispatch(showAlertSnackbar({
          title: t('daily_log'),
          message: t('dialog:daily_log_search_failed'),
          type: 'error'
        }));
      });
      setIsDataLoading(false);
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  const handleDateChange = (event) => {
    setSelectedDate(event.target.value);
  };

  const handleDriverIdChange = (event) => {
    setDriverId(event.target.value);
  };

  const updateAllDriverDetails = (newAllDriverDetails) => {
    setAllDriverDetails(newAllDriverDetails);
  };

  const handleBatchInfoChange = (event) => {
    setBatchInfo(event.target.value);
  };

  const handleLogHourSubmit = () => {
    let logs = [];
    if (!_.isNil(selectedItem) && selectedItem !== "") {
      logs = selectedItem.map(item => {
        const hours = parseFloat(item.date_hours);
  
        if (hours === 0) {
          return null; // Skip items with date_hours = 0
        }
  
        return {
          staff_id: parseInt(item.driver_id),
          hours: hours,
        };
      });
  
      logs = logs.filter(log => log !== null); // Remove null entries
    }
  
    const invalidHours = logs.some(log => log.hours < 0 || log.hours > 24);
  
    if (invalidHours) {
      dispatch(showAlertSnackbar({
        title: t('daily_log'),
        message: t('dialog:invalid_hours_value'),
        type: 'error'
      }));
      return; // Exit function if hours are invalid
    } else {
      const params = {
        logs: logs,
        date: selectedDate,
        warehouse: userPref.userCity,
      };
      setIsDataLoading(true);
      dispatch(createDailyLog(params))
        .then((response) => {
          dispatch(showAlertSnackbar({
            title: t('daily_log'),
            message: t('dialog:log_hours_success'),
            type: 'success'
          }));
        })
        .catch((error) => {
          dispatch(showAlertSnackbar({
            title: t('daily_log'),
            message: t('dialog:log_hours_failed'),
            type: 'error'
          }));
        })
        .finally(() => {
          setIsDataLoading(false);
          handleSearch();  // Call handleSearch in the finally block
        });
  
    }
  };
  

  useEffect(() => {
    const branchTimezone = _.filter(
      Object.values(JSON.parse(window.localStorage.getItem('branches'))), (item) => {
        return item.city === parseInt(window.localStorage.getItem('user_city'));
      })
    if (!_.isEmpty(branchTimezone)) {
      setTimezone(branchTimezone[0]?.time_zone)
    }
  }, []);

  return (
    <>
      <Grid container spacing={0}>
        <Grid item xs={1} className={classes.grid}>
          <TextField
            id="dailylog_selectddate_textfield"
            label={t('date')}
            type="date"
            defaultValue={selectedDate}
            onChange={handleDateChange}
            InputLabelProps={{
              shrink: true,
            }}
            className={classes.textField}
          />
        </Grid>
        <Grid item xs={1} className={classes.grid}>
          <TextField
            id="dailylog_driverid_textfield"
            label={t('driver_id')}
            value={driverId}
            onChange={handleDriverIdChange}
            fullWidth
            className={classes.textField}
          />
        </Grid>
        <Grid item xs={1} className={classes.grid}>
          <TextField
            id="dailylog_batchinfo_textfield"
            label={t('batch_info')}
            value={batchInfo}
            onChange={handleBatchInfoChange}
            fullWidth
            className={classes.textField}
          />
        </Grid>
        <Grid item xs={0.5} className={classes.grid}>
          <IconButton id="dailylog_seachdailylog_iconbutton" color="primary" className={classes.searchButton} onClick={handleSearch}
          >
            <Search className={classes.icon} />
          </IconButton>
        </Grid>
        <Grid item xs={0.5} className={classes.grid}>
          <IconButton id="dailylog_refreshdailylog_iconbutton" color="primary" className={classes.refreshButton} onClick={handleRefresh}
          >
            <Refresh className={classes.icon} />
          </IconButton>
        </Grid>
        <Grid item xs={6} className={classes.grid}>
          <Button
            id="dailylog_loghour_button"
            variant="contained"
            color="primary"
            className={classes.Button}
            onClick={handleLogHourSubmit}
            disabled={!selectedItem || selectedItem.length === 0}
          >
            {t("log_hour")}
          </Button>
        </Grid>
        <Grid item xs={12} >
          <DailyLogTable
            allDriverDetails={allDriverDetails}
            isDataLoading={isDataLoading}
            setSelectedItems={handleSelectedItems}
            updateAllDriverDetails={updateAllDriverDetails}
            timezone={timezone}
            handleSearch={handleSearch}
          />
        </Grid>
      </Grid>
    </>
  );
}
export default PayrollDailyLog;